import { theme } from '@/styles';
import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { IconProps } from './types/Icon.type';

interface AptRankIconProps extends IconProps {
  children: ReactNode;
}

function AptRankIcon({ children, ...props }: AptRankIconProps) {
  return (
    <BadgeContainer>
      <svg
        width="36"
        height="44"
        viewBox="0 0 36 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 0H36V44L18 37.1034L0 44V0Z"
          fill={props?.fill ?? '#FFF3B2'}
        />
      </svg>
      <ChildrenBox>{children}</ChildrenBox>
    </BadgeContainer>
  );
}

export default AptRankIcon;

const BadgeContainer = styled.div`
  position: relative;
  width: 36px;
  height: 44px;
`;

const ChildrenBox = styled.div`
  width: 36px;
  height: 28px;
  position: absolute;
  text-align: center;
  top: 6px;
  color: ${theme.colors.accent_colors.primary.default};
  ${theme.typography.subtitle4};
`;
